import {
  AccordionField,
  BaseObjectField,
  FieldsetField,
  NumberField,
  SchemaField,
  StringField,
  TabField,
  TabsField,
  TableField,
  TableRowField,
} from './fields';
import {
  CheckboxesWidget,
  CheckboxWidget,
  CommentWidget,
  ImageWidget,
  RadioWidget,
  SelectWidget,
  SignatureWidget,
  TextareaWidget,
  TextWidget,
} from './widgets';

export const widgets = {
  CheckboxesWidget,
  CheckboxWidget,
  comment: CommentWidget,
  date: TextWidget,
  image: ImageWidget,
  RadioWidget,
  SelectWidget,
  signature: SignatureWidget,
  TextareaWidget,
  TextWidget,
};

export const fields = {
  accordion: AccordionField,
  fieldset: FieldsetField,
  integer: NumberField,
  number: NumberField,
  object: BaseObjectField,
  SchemaField,
  StringField,
  tab: TabField,
  tabs: TabsField,
  table: TableField,
  tablerow: TableRowField,
};

export { default as SchemaForm } from './SchemaForm';
export { default as SchemaView} from './SchemaView';


// WEBPACK FOOTER //
// ./src/modules/common/components/form/index.js